// extracted by mini-css-extract-plugin
export default {"Expandable":"Expandable_Expandable__7fB3p","Cont":"Expandable_Cont__64h8-"};